import SecureStorage from 'secure-web-storage';
import CryptoJS from 'crypto-js';

import isBrowser from '@util/isBrowser';

export const STORAGE_TYPE = Object.freeze({
  LOCAL: 'local',
  SESSION: 'session',
});

const storageMethods = {
  [STORAGE_TYPE.LOCAL]: isBrowser ? localStorage : {},
  [STORAGE_TYPE.SESSION]: isBrowser ? sessionStorage : {},
};

function createSecureStorage(storageMethod) {
  return new SecureStorage(storageMethod, {
    hash: function hash(key) {
      key = CryptoJS.SHA256(key, process.env.STORAGE_SECRET_KEY);

      return key.toString();
    },
    encrypt: function encrypt(data) {
      data = CryptoJS.AES.encrypt(data, process.env.STORAGE_SECRET_KEY);

      data = data.toString();

      return data;
    },
    decrypt: function decrypt(data) {
      data = CryptoJS.AES.decrypt(data, process.env.STORAGE_SECRET_KEY);

      data = data.toString(CryptoJS.enc.Utf8);

      return data;
    },
  });
}

const secureStorageByType = {
  [STORAGE_TYPE.LOCAL]: createSecureStorage(storageMethods[STORAGE_TYPE.LOCAL]),
  [STORAGE_TYPE.SESSION]: createSecureStorage(
    storageMethods[STORAGE_TYPE.SESSION]
  ),
};

function getValidatedStorageType(storageType) {
  const validTypes = Object.values(STORAGE_TYPE);
  if (!validTypes.includes(storageType)) {
    throw new Error(
      `Invalid storage type "${storageType}". Expected one of: ${validTypes.join(', ')}`
    );
  }
  return storageType;
}

function parseJsonWithDefault(rawValue, defaultValue) {
  if (rawValue == null) {
    return defaultValue;
  }

  try {
    return JSON.parse(rawValue);
  } catch (err) {
    return defaultValue;
  }
}

export const getStorageItem = (
  storageType,
  storageKey,
  defaultValue = null,
  encrypt = process.env.ENABLE_DEV_FEATURES === 'true'
) => {
  if (!isBrowser) {
    return defaultValue;
  }

  const validatedStorageType = getValidatedStorageType(storageType);
  const storageMethod = storageMethods[validatedStorageType];
  const secureStorage = secureStorageByType[validatedStorageType];

  if (encrypt) {
    try {
      return secureStorage.getItem(storageKey) ?? defaultValue;
    } catch {
      return defaultValue;
    }
  }

  return parseJsonWithDefault(storageMethod.getItem(storageKey), defaultValue);
};

export const setStorageItem = (
  storageType,
  storageKey,
  value,
  encrypt = process.env.ENABLE_DEV_FEATURES === 'true'
) => {
  if (!isBrowser) {
    return;
  }

  const validatedStorageType = getValidatedStorageType(storageType);
  const storageMethod = storageMethods[validatedStorageType];
  const secureStorage = secureStorageByType[validatedStorageType];

  if (encrypt) {
    secureStorage.setItem(storageKey, value);
  } else {
    storageMethod.setItem(storageKey, JSON.stringify(value));
  }
};
